import { useApiQuery } from '@portals-platform/api-client';
import { keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ENDPOINTS } from '../api/endpoints.js';
import type { CertificateListResponse } from '../api/responses.js';
import { toCertificateList, toCertificateSearchQuery } from '../mappers/certificate-mappers.js';
import type { CertificateSearchParams } from '../models.js';
import { queryKeys } from '../query-keys.js';

export function useCertificateSearch(params: CertificateSearchParams) {
  const { data, isLoading, isError, error } = useApiQuery<CertificateListResponse>(
    [...queryKeys.certificateSearch(params)],
    ENDPOINTS.certificatesSearch,
    { params: toCertificateSearchQuery(params) },
    { placeholderData: keepPreviousData },
  );

  const list = useMemo(() => toCertificateList(data), [data]);

  return { ...list, isLoading, isError, error };
}
